<template>
    <div v-on:click="toClients">
        <CRow>
            <CCol>
                <CWidgetProgressIcon :header="clientsCount"
                                     text="My Clients"
                                     color="primary"
                                     :value="100"
                                     style="height:188px">
                    <CIcon name="cil-people" height="36" />
                </CWidgetProgressIcon>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from 'vue';
    import apis from '@/common/network';

    export default Vue.extend({
        created() {
            this.fetchClientsData()
        },
        data() {
            return {
                clientsCount: "-"
            }
        },
        methods: {
            fetchClientsData: function () {
                apis.protectedApi('utils/activeClients')
                    .then(response => {
                        this.clientsCount = response.data.length.toLocaleString();
                    }).catch(e => {

                    });
            },
            toClients(args) {
                this.$router.push({ name: 'Clients' });
            }
        }
    })
</script>

<style scoped>

</style>